import CloseButton from "../../buttons/close.button";
import { useEffect, useState } from "react";

const ParentOptionsTextInput = ({
  options = [],
  setValue = () => {},
  formFields,
  name = "",
}) => {
  const [selected, setSelected] = useState([]);
  const [searchValues, setSearchValues] = useState([]);
  const [customValues, setCustomValues] = useState([]);
  const [searchTextValue, setSearchTextValue] = useState("");

  const onOptionClick = (e) => {
    const id = e.currentTarget.dataset.id;
    const option = options.find((opt) => opt.id === id);
    const existingSelection = selected.find((opt) => opt.id === option.id);

    if (!option) return console.error("Option not found");
    if (!existingSelection) {
      setSelected((prev) => [...prev, option]);
      setSearchValues((prev) => [...prev, ...option.value]);
    } else {
      setSelected((prev) => prev.filter((opt) => opt.id !== option.id));
      setSearchValues((prev) =>
        prev.filter((val) => !option.value.includes(val))
      );
    }
  };

  const handleValueRemoval = (value, id) => {
    if (!id) {
      setCustomValues((prev) => prev.filter((val) => val !== value));
      setSearchValues((prev) => prev.filter((val) => val !== value));
      return;
    }

    setSelected((prev) =>
      prev.map((opt) =>
        opt.id === id
          ? { ...opt, value: opt.value.filter((val) => val !== value) }
          : opt
      )
    );
    setSearchValues((prev) => prev.filter((val) => val !== value));
  };

  const handleSelectionRemoval = (id) => {
    const option = options.find((opt) => opt.id === id);
    if (!option) return console.error("Option not found");
    setSelected((prev) => prev.filter((opt) => opt.id !== id));
    setSearchValues((prev) =>
      prev.filter((val) => !option.value.includes(val))
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddValue(event);
    }
  };

  const handleAddValue = (e) => {
    e.preventDefault();
    if (!searchTextValue) return;
    if (searchValues.includes(searchTextValue)) {
      return alert("Value already exists");
    }
    setSearchValues((prev) => [...prev, searchTextValue]);
    setCustomValues((prev) => [...prev, searchTextValue]);
    setSearchTextValue("");
  };

  const isSelected = (option) => {
    if (!selected.length) return "bg-slate-100";
    if (selected.find((opt) => opt.id === option.id)) {
      return "bg-slate-400";
    }
  };

  useEffect(() => {
    if (!!!searchValues.length) return;

    setValue((prev) => ({ ...prev, [name]: searchValues }));
  }, [searchValues]);

  return (
    <div className="text-black bg-white w-96 h-64 flex flex-row p-1 rounded">
      <div className="relative bg-slate-300 w-2/3 h-full">
        <div className="flex flex-row flex-wrap w-full bg-slate-200 gap-2 p-1 rounded overflow-x-auto h-56 px-1 pt-1 pb-4">
          {!!customValues.length &&
            customValues.map((val) => (
              <div
                key={val}
                className="items-center w-fit p-1 gap-2 flex justify-start bg-slate-300 rounded"
              >
                <span>{val}</span>
                <CloseButton
                  onClose={() => handleValueRemoval(val)}
                  size="sm"
                />
              </div>
            ))}
          {!!selected.length &&
            selected.map((selection) => (
              <div
                key={`selected-${selection.id}`}
                className="p-1 flex flex-col gap-1 justify-start bg-slate-300 rounded"
              >
                <div className="flex w-full justify-between items-center">
                  <label>{selection.name}</label>
                  <CloseButton
                    onClose={() => handleSelectionRemoval(selection.id)}
                    size="sm"
                  />
                </div>
                <div className="flex flex-row gap-1 flex-wrap">
                  {selection.value.map((val) => (
                    <div
                      key={val}
                      className="items-center w-fit p-1 gap-2 flex justify-start bg-slate-200 rounded"
                    >
                      <span>{val}</span>
                      <CloseButton
                        onClose={() => handleValueRemoval(val, selection.id)}
                        size="sm"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
        <div
          onSubmit={handleAddValue}
          className="w-full absolute bottom-0 flex flex-row"
        >
          <input
            className="w-full px-2 rounded-sm"
            type="text"
            placeholder="Add search text..."
            name="searchText"
            onChange={(e) => setSearchTextValue(e.target.value)}
            value={searchTextValue}
            onKeyDown={handleKeyDown}
          />
          <button
            onClick={handleAddValue}
            className="hover:bg-secondary text-white bg-primary flex text-nowrap py-1 px-2 shadow-black shadow-sm"
          >
            Add +
          </button>
        </div>
      </div>
      <div className="flex flex-col bg-slate-100 w-1/3 h-full p-2 gap-1 overflow-x-auto">
        {!!options.length &&
          options.map((option) => (
            <div
              onClick={onOptionClick}
              key={option.id}
              data-id={option.id}
              className={`${isSelected(
                option
              )} cursor-pointer p-1 gap-2 flex items-center justify-between bg-slate-200 rounded`}
            >
              <span>{option.name}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ParentOptionsTextInput;
